import owd from 'owd/owd';
import 'jquery-mousewheel';
import EventEmitter from 'eventemitter2';

export class FullPageDriver {
    constructor(fullPageInstance) {

    }
}


export default class FullPage extends owd.Module {
    constructor(app) {
        super(app);
        this.allowDrag = false;
        this.dragMax = $(window).height();
        this.dragMin = 40;
        this.views = [];
        this.eventEmitter = new EventEmitter();
        this.eventEmitter.setMaxListeners(200);
    }

    init() {
        this.isEnabled = true;
        this.isEnabledUp = true;
        this.isEnabledUpTouch = true;
        this.isEnabledDown = true;
        this.isEnabledDownTouch = true;

        this.bindKeyboard();
        this.bindMouseWheel();
        this.bindTouch();
        this.bindResize();
    }

    enable() {
        this.isEnabled = true;
    }

    disable() {
        this.isEnabled = false;
    }

    enableUp(mode) {
        if (mode === 'touch') {
            this.isEnabledUpTouch = true;
        } else {
            this.isEnabledUpTouch = true;
            this.isEnabledUp = true;
        }
    }

    disableUp(mode) {
        if (mode === 'touch') {
            this.isEnabledUpTouch = false;
        } else {
            this.isEnabledUpTouch = false;
            this.isEnabledUp = false;
        }
    }

    enableDown(mode) {
        if (mode === 'touch') {
            this.isEnabledDownTouch = true;
        } else {
            this.isEnabledDownTouch = true;
            this.isEnabledDown = true;
        }
    }

    disableDown(mode) {
        if (mode === 'touch') {
            this.isEnabledDownTouch = false;
        } else {
            this.isEnabledDownTouch = false;
            this.isEnabledDown = false;
        }
    }

    setDrag(allow) {
        this.allowDrag = allow ? true : false;

        return this;
    }

    emit(...args) {
        this.eventEmitter.emit.apply(this.eventEmitter, args);
        return this;
    }

    on(...args) {
        this.eventEmitter.on.apply(this.eventEmitter, args);
        return this;
    }

    off(...args) {
        this.eventEmitter.off.apply(this.eventEmitter, args);
        return this;
    }

    addView(view) {
        this.views.push(view);

        $('html').addClass('has-fullpage');

        return this;
    }

    removeView(view) {
        let index = this.views.indexOf(view);

        if (index >= 0) {
            this.views.splice(index, 1);
        }

        if (!this.views.length) {
            $('html').removeClass('has-fullpage');
        }

        return this;
    }

    setDriver(Driver) {
        this.driver = new Driver(this);

        return this;
    }

    getDriver() {
        if (!this.driver) {
            this.driver = new FullPageDriver(this);
        }

        return this.driver;
    }

    up({ source }) {
        this.emit('up', {
            source
        });
    }

    down({ source }) {
        this.emit('down', {
            source
        });
    }

    dragMove(pos) {
        this.emit('drag-move', pos);
    }

    dragRelease() {
        this.emit('drag-release');
    }

    isAllEnabled() {
        return this.isEnabled && this.views.length;
    }

    bindKeyboard() {
        this.app.dom.$html.on('keydown', (e) => {
            if (this.isAllEnabled() && !$(e.target).is('input,textarea,[contenteditable]')) {
                if (e.keyCode == 40 && (this.isEnabledDown || isEnabledDownTouch)) {
                    e.preventDefault();
                    this.down({ source: 'keyboard' });
                } else if (e.keyCode == 38 && (this.isEnabledUp || this.isEnabledUpTouch)) {
                    e.preventDefault();
                    this.up({ source: 'keyboard' });
                }
            }
        });
	}

    // inspired by https://github.com/alvarotrigo/fullPage.js/blob/master/jquery.fullPage.js
	bindMouseWheel() {
        let scrollings = [];
		let currentTime, prevTime, timeDiff, averageEnd, averageMiddle, isAccelerating, deltaY;

        prevTime = new Date().getTime();
        
        const _listener = (e) => {
            if (this.isAllEnabled()) {
                if (e.originalEvent) {
                    deltaY = e.originalEvent.deltaY;
                } else if (e.axis) {
                    deltaY = (e.axis === 1 ? 0 : e.detail);
                } else {
                    deltaY = e.deltaY;
                }

                if ((deltaY <= 0 && (this.isEnabledUp || this.isEnabledUpTouch)) || 
                    (deltaY >= 0 && (this.isEnabledDown || this.isEnabledDownTouch))) {
                    e.preventDefault();

                    currentTime = new Date().getTime();

                    if (scrollings.length > 149) {
                        scrollings.shift();
                    }

                    scrollings.push(Math.abs(deltaY));

                    timeDiff = currentTime - prevTime;
                    prevTime = currentTime;

                    if (timeDiff > 200) {
                        scrollings = [];
                    }

                    averageEnd = this._getAverage(scrollings, 10);
                    averageMiddle = this._getAverage(scrollings, 70);
                    isAccelerating = averageEnd >= averageMiddle;

                    if (isAccelerating && deltaY < 0) {
                        this.up({ source: 'mousewheel' });
                    } else if (isAccelerating && deltaY > 0) {
                        this.down({ source: 'mousewheel' });
                    }
                }
            }
        };

        if (/Firefox/i.test(navigator.userAgent)) {
            window.addEventListener('DOMMouseScroll', _listener, { passive: false });
        } else if (navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            window.addEventListener('wheel', _listener, { passive: false });
        } else {
            this.app.dom.$window[0].addEventListener('mousewheel', _listener, { passive: false });
            this.app.dom.$window[0].addEventListener('DOMMouseScroll', _listener, { passive: false });
        }

	}

    bindTouch() {
		let lastX, lastY;
        let startX, startY;
        let dragOffset;
        let currTouch;
        let direction = 0;
        
        this.isDragging = false;

        this.app.dom.$html[0].addEventListener('touchstart', (e) => {
            if (this.isAllEnabled()) {
                if (!$(e.target).is('input,textarea,[contenteditable],.header') && 
                    !$(e.target).parents('.header').length) {

                    lastX = e.touches[0].clientX;
                    lastY = e.touches[0].clientY;

                    startX = lastX;
                    startY = lastY;
                }
            }
        }, { passive: false });


		this.app.dom.$html[0].addEventListener('touchend', (e) => {
            if (this.isAllEnabled() && this.isDragging) {

                $('.scrollable, .fp-wrapper-inner').css('touch-action', 'auto');
                $('.scrollable').css('overflow', '');

                let release = true;

                if (this.allowDrag && currTouch !== undefined) {
                    if (!$(e.target).is('input,textarea,[contenteditable]')) {
                        e.preventDefault();
                    }

                    if (lastX !== undefined && lastY !== undefined &&
                        Math.abs(lastY - currTouch.clientY) > this.dragMin) {
                            
                        if (lastY > currTouch.clientY && direction > 0 && 
                            (this.isEnabledDown || this.isEnabledDownTouch)) {

                            this.down({ source: 'touch' });
                            release = false;

                        } else if (lastY < currTouch.clientY && direction < 0 &&
                             (this.isEnabledUp || this.isEnabledUpTouch)) {

                            this.up({ source: 'touch' });
                            release = false;
                        }
                    }

                    this.isDragging = false;
                }

                if (release && currTouch !== undefined) {
                    this.dragRelease();
                }

                setTimeout(() => {
                    this.app.dom.$window.trigger('fp-scroll-unlock');
                });
            }

            lastX = undefined;
            lastY = undefined;
            currTouch = undefined;
		}, { passive: false });

        this.app.dom.$html[0].addEventListener('touchmove', (e) => {
            if (e.preventedByNestedSwiper) {
                return;
            }

            if (this.isAllEnabled()) {
                if (currTouch && currTouch.clientY < e.touches[0].clientY) {
                    direction = -1;
                } else if (currTouch && currTouch.clientY > e.touches[0].clientY) {
                    direction = 1;
                }  else {
                    direction = 0;
                }

                currTouch = jQuery.extend({}, e.touches[0]);

                if (!this.isDragging) {
                    if (((lastY < currTouch.clientY && (this.isEnabledUp || this.isEnabledUpTouch)) || 
                        (lastY > currTouch.clientY && (this.isEnabledDown || this.isEnabledDownTouch))) &&
                        Math.abs(lastX - currTouch.clientX) < Math.abs(lastY - currTouch.clientY)) {
                        this.isDragging = true;
                        $('.scrollable, .fp-wrapper-inner').css('touch-action', 'none');
                        $('.scrollable').css('overflow', 'hidden');
                    } else {
                        lastX = undefined;
                        lastY = undefined;
                        currTouch = undefined;
                    }
                } 
                
                if (this.isDragging) {
                    if ((lastY < currTouch.clientY && (this.isEnabledUp || this.isEnabledUpTouch)) || 
                        (lastY > currTouch.clientY && (this.isEnabledDown || this.isEnabledDownTouch))) {

                        if (!$(e.target).is('input,textarea,[contenteditable]')) {
                            e.preventDefault();
                        }

                        if (this.allowDrag) {
                            dragOffset = currTouch.clientY - lastY;
                            dragOffset = Math.min(dragOffset, this.dragMax);
                            dragOffset = Math.max(dragOffset, this.dragMax * -1);

                            if (!(this.isEnabledUp || this.isEnabledUpTouch) && dragOffset > 0) {
                                dragOffset = 0;
                            }

                            if (!(this.isEnabledDown || this.isEnabledDownTouch) && dragOffset < 0) {
                                dragOffset = 0;
                            }

                            this.dragMove(dragOffset);
                        } else {
                            if (lastX !== undefined && lastY !== undefined &&
                                Math.abs(lastX - currTouch.clientX) < Math.abs(lastY - currTouch.clientY) &&
                                Math.abs(lastY - currTouch.clientY) > 10) {

                                if (lastY > currTouch.clientY) {
                                    this.down({ source: 'touch' });
                                } else {
                                    this.up({ source: 'touch' });
                                }

                                lastX = undefined;
                                lastY = undefined;
                                currTouch = undefined;
                            }
                        }
                    }
                }
            }
		}, { passive: false });
	}

    bindResize() {
        this.app.dom.$window.on('resize', () => {
            this.dragMax = this.app.dom.$window.height();
        });
    }

    // function getAverage from MIT licensed library:
    // https://github.com/alvarotrigo/fullPage.js
    _getAverage(elements, number) {
        let sum = 0;

        let lastElements = elements.slice(Math.max(elements.length - number, 1));

        for (let i = 0; i < lastElements.length; i++) {
            sum = sum + lastElements[i];
        }

        return Math.ceil(sum/number);
    }
}